var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReportBtnDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 18.4199L9.01921 13.4391L10.2489 12.1739L13.125 15.05V5.25H14.875V15.05L17.7511 12.1739L18.9808 13.4391L14 18.4199ZM7.35904 22.75C6.76968 22.75 6.27083 22.5458 5.8625 22.1375C5.45417 21.7292 5.25 21.2303 5.25 20.641V17.4775H7V20.641C7 20.7308 7.03743 20.813 7.11229 20.8877C7.18696 20.9626 7.26921 21 7.35904 21H20.641C20.7308 21 20.813 20.9626 20.8877 20.8877C20.9626 20.813 21 20.7308 21 20.641V17.4775H22.75V20.641C22.75 21.2303 22.5458 21.7292 22.1375 22.1375C21.7292 22.5458 21.2303 22.75 20.641 22.75H7.35904Z",
    fill: "#00559E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportBtnDown);
export default __webpack_public_path__ + "static/media/report_btn_down.60d504d4dc5fc4e4b1a31bf002dde558.svg";
export { ForwardRef as ReactComponent };